import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UsuarioService } from 'src/app/services/http/usuario.service';

@Component({
  selector: 'app-autorizar-dispositivo',
  templateUrl: './autorizar-dispositivo.component.html',
  styleUrls: ['./autorizar-dispositivo.component.scss']
})
export class AutorizarDispositivoComponent implements OnInit {

  status: 'sucesso' | 'erro' | 'carregando' = 'carregando';
  mensagem: string = '';

  constructor(
    private route: ActivatedRoute,
    private usuarioService: UsuarioService,
  ) { }

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.status = 'erro';
      this.mensagem = 'Token não informado.';
      return;
    }

    this.usuarioService.autorizarDispositivo(token)
      .then(() => {
        this.status = 'sucesso';
        this.mensagem = 'Dispositivo autorizado com sucesso! Você já pode acessar o sistema.';
      })
      .catch(( err) => {
        console.log(err)
        this.status = 'erro';
        this.mensagem = 'Erro ao autorizar o dispositivo. Verifique o link ou entre em contato com o suporte.';
      });
  }

}

